export default {"src":"/_next/static/media/users.d82442aa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};